import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

export const useLarkWebhookStatus = () => {
  const scope = useScopedMerchantClient();
  return useQuery({
    queryKey: ["lark-webhook-clients", "status", scope.merchantId, scope.workspaceId],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"]["lark-webhook-clients"].status.$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"]["lark-webhook-clients"].status.$get({
            param: scope.param,
          });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    enabled: !!scope.merchantId,
    staleTime: 5 * 60 * 1000,
  });
};
